module.exports = "/images/hamburger.svg";